import { render, staticRenderFns } from "./DadosSistemas.vue?vue&type=template&id=4d1d6413&"
import script from "./DadosSistemas.vue?vue&type=script&lang=js&"
export * from "./DadosSistemas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports